module.exports = __webpack_public_path__ + "static/img/maisui2.12f638e6.png";